// Module
var code = "<button class=\"button is-small\" id=\":elementId\"> <span class=\"icon is-small is-hidden\"> <i class=\"fa-solid fa-check\"></i> </span> <span>:label</span> </button> ";
// Exports
export default code;